import React from "react";
import { Wand2, CheckCircle2, Eye, Image as ImageIcon, Sparkles } from "lucide-react";

const Tile = ({ label, value, icon: Icon, color }) => (
  <div className={`bg-${color}-50 border border-${color}-100 rounded-xl p-3`}>
    <div className="flex items-center gap-1.5 text-xs text-[#64748B] mb-1">
      <Icon size={12} /> {label}
    </div>
    <div className="text-xl font-bold text-[#1E1B4B]">{(value || 0).toLocaleString("en-IN")}</div>
  </div>
);

export const DashboardCards = ({ d }) => (
  <div className="space-y-5">
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
      <Tile label="Drafts (7d)" value={d.drafts_generated} icon={Wand2} color="purple" />
      <Tile label="Published" value={d.posts_published} icon={CheckCircle2} color="emerald" />
      <Tile label="Reach" value={d.total_reach} icon={Eye} color="pink" />
      <Tile label="Impressions" value={d.total_impressions} icon={ImageIcon} color="indigo" />
      <Tile label="Engagement" value={d.total_engagement} icon={Sparkles} color="amber" />
    </div>
    {d.best_post && (
      <div className="bg-gradient-to-br from-emerald-50 to-pink-50 border border-emerald-200 rounded-2xl p-5">
        <div className="text-xs font-semibold text-emerald-700 uppercase tracking-wider mb-1">Top performer</div>
        <div className="text-base font-bold text-[#1E1B4B] mb-1">{d.best_post.theme_name}</div>
        <p className="text-xs text-[#64748B] line-clamp-2">{d.best_post.caption}</p>
        <div className="text-sm text-[#DC283C] font-semibold mt-2">Reach: {d.best_post.reach?.toLocaleString("en-IN")}</div>
      </div>
    )}
    {Object.keys(d.by_theme || {}).length > 0 && (
      <div className="bg-white border border-gray-200 rounded-2xl p-5">
        <h4 className="text-sm font-bold text-[#1E1B4B] mb-3">Theme distribution (last 7d)</h4>
        <div className="space-y-2">
          {Object.entries(d.by_theme).map(([id, count]) => (
            <div key={id} className="flex items-center justify-between text-xs">
              <span className="text-[#1E1B4B]">{id.replace(/_/g, " ")}</span>
              <span className="font-semibold text-[#DC283C]">{count}</span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
